import { Box, Typography } from '@mui/material';
import { MapContainer, TileLayer, Polyline, CircleMarker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

/**
 * Renders a GPS route recorded during a workout (e.g. outdoor running/cycling)
 * using OpenStreetMap tiles via Leaflet. `route` is an array of
 * { lat: number, lng: number } points, already downsampled by the mobile app.
 */
export default function WorkoutRouteMap({ route, height = 260, color = '#5840DB' }) {
  if (!Array.isArray(route) || route.length < 2) {
    return (
      <Box sx={{ py: 3, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          Brak danych GPS dla tego treningu.
        </Typography>
      </Box>
    );
  }

  const positions = route.map((p) => [p.lat, p.lng]);

  let minLat = positions[0][0];
  let maxLat = positions[0][0];
  let minLng = positions[0][1];
  let maxLng = positions[0][1];
  for (const [lat, lng] of positions) {
    if (lat < minLat) minLat = lat;
    if (lat > maxLat) maxLat = lat;
    if (lng < minLng) minLng = lng;
    if (lng > maxLng) maxLng = lng;
  }
  const bounds = [
    [minLat, minLng],
    [maxLat, maxLng],
  ];

  return (
    <Box sx={{ height, borderRadius: 2, overflow: 'hidden', border: '1px solid rgba(0,0,0,0.08)' }}>
      <MapContainer
        bounds={bounds}
        boundsOptions={{ padding: [24, 24] }}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Polyline positions={positions} pathOptions={{ color, weight: 4, opacity: 0.85 }} />
        <CircleMarker center={positions[0]} radius={6} pathOptions={{ color: '#17845B', fillColor: '#17845B', fillOpacity: 1 }} />
        <CircleMarker center={positions[positions.length - 1]} radius={6} pathOptions={{ color: '#A96400', fillColor: '#A96400', fillOpacity: 1 }} />
      </MapContainer>
    </Box>
  );
}
